/**
 *
 * FlashCardLanding
 *
 */

import { FlashCardItemMixin } from '@/scripts/FlashCard/FlashCardLanding/mixins/FlashCardItemMixin';

export default {
  name: 'MainModeFlashCardItem',

  mixins: [FlashCardItemMixin],
};
